import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModuleMenu } from 'src/app/models/common';

@Injectable()
export class HeadService {

  private headerSource: BehaviorSubject<ModuleMenu> = new BehaviorSubject(null);
  currentMessage = this.headerSource.asObservable();

  private appSource: BehaviorSubject<ModuleMenu> = new BehaviorSubject(null);
  appMessage = this.appSource.asObservable();

  constructor() { }

  getHeader(): Observable<ModuleMenu> {
    return this.headerSource.asObservable();
  }

  setHeader(menu: ModuleMenu) {
    this.headerSource.next(menu);
  }

  getApp(): Observable<ModuleMenu> {
    return this.appSource.asObservable();
  }

  setApp(menu: ModuleMenu) {
    this.appSource.next(menu);
  }
}
